import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';

const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
const PageLoad = (PageLoadBo) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManualStockAdjustment,
            SDIConstants.methodNames.ManualStockAdjustment_PageLoad,
            JSON.stringify(PageLoadBo),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PageLoad", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const SearchItem = (SearchItemBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManualStockAdjustment,
            SDIConstants.methodNames.ManualStockAdjustment_SearchItem,
            JSON.stringify(SearchItemBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "SearchItem", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const AdjConfSubmit = (AdjConfSubmitBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManualStockAdjustment,
            SDIConstants.methodNames.ManualStockAdjustment_AdjConfSubmitClick,
            JSON.stringify(AdjConfSubmitBO),
            (data) => {
                if (data.success) {
                    
                    if (data.response != "" && data.response) {
                        let contentData = { type: "AdjConfSubmit", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

//PC_CPW_231_11
const reorderCheckAction = async (ReorderBO) => {
    try {
        //PC_CPW_231_12
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManualStockAdjustment,
            SDIConstants.methodNames.ManualStockAdjustment_reorderCheck,
            JSON.stringify(ReorderBO),
            //PC_CPW_231_13
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "reorder", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    }
    //PC_CPW_231_11
    catch (ex) {
        console.log(ex)
    }
};

//PC_CPW_231_28
const reorderSubmitAction = async (ReorderBO) => {
    try {
        //PC_CPW_231_29
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ManualStockAdjustment,
            SDIConstants.methodNames.ManualStockAdjustment_reorderSubmitClick,
            JSON.stringify(ReorderBO),
            //PC_CPW_231_30
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "submitReorder", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    }
    //PC_CPW_231_31
    catch (ex) {
        console.log(ex)
    }
};


export {
    PageLoad, SearchItem, AdjConfSubmit, getCurrentFavPage, deleteFavPage, insertFavPage, reorderCheckAction, reorderSubmitAction
}